// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"47d87d4b","36":"0a8edfd4","221":"fc96f0f0","229":"2f59fe79","251":"bfec96a1","286":"21cc0ffe","295":"ebb99f51","335":"793d9323","371":"1a871fc4","621":"fe6da7a6","681":"33778a77","787":"d88e774f","816":"e28f0cbe","893":"ef80f572","922":"1628854a","966":"a7c66316"}[chunkId] + ".chunk.js";
};